import { Image, Link, Text, View } from '@react-pdf/renderer';
import React, { useContext } from "react";
import { GroupSettingsContext } from '../../../contexts/GroupSettingsContext';
import theme from "../../../theme";
import { ColorOptions } from '../../../theme/colors';
import { Dashboard } from "../../../types/files";
import styles from "./styles";

const PDFHeader: React.FC<{ dashboard: Dashboard|null }> = ({ dashboard }) => {
    const { statuses } = useContext(GroupSettingsContext);

    const palettes = Array.from(new Set(Object.values(ColorOptions)
        .filter(color => !['neutral', 'brown', 'lime', 'pink', 'red', 'shades'].includes(color))));

    const getChipBgColors = (title: string) => {
        const index = statuses.findIndex((s) => s.toLowerCase() === title.toLowerCase());

        if ((index !== -1) && (index < palettes.length))
            return theme.colors[palettes[index]][100];

        return theme.colors.neutral[100];
    };

    const getChipTextColor = (title: string) => {
        const index = statuses.findIndex((s) => s.toLowerCase() === title.toLowerCase());

        if ((index !== -1) && (index < palettes.length))
            return theme.colors[palettes[index]][800];

        return theme.colors.neutral[800];
    };

    return (<>
        <View style={styles.header} fixed>
            <View style={styles.headerMain}>
                <Link src={'https://notissia.com'}> !!;sa
                    <Image style={styles.headerLogo} src={'/images/notissia-ativo-2-logo.png'} />
                </Link>
                <View style={styles.headerSub}>
                    <View style={styles.headerLeft}>
                        <Text style={styles.headerTitle}>
                            {dashboard?.title}
                        </Text>
                    </View>
                    {!!dashboard?.status && (<>
                        <View style={styles.headerRight}>
                            <Text style={{...styles.headerTextRight, marginRight: 8}}>
                                {'Status'}
                            </Text>
                            <View style={{...styles.headerChip, backgroundColor: getChipBgColors(dashboard?.status?.toLowerCase())}}>
                                <Text style={{...styles.headerChipText, color: getChipTextColor(dashboard?.status?.toLowerCase())}}>
                                    {dashboard?.status}
                                </Text>
                            </View>
                        </View>
                    </>)}
                </View>
            </View>
            <View style={{...styles.topDivider, marginTop: 8, marginBottom: 8 }} />
        </View>
    </>);
}

export default PDFHeader;